export default [
    {
        path: '/',
        redirect: '/bills',
        name: 'Dashboard',
        component: () => import('@/views/Dashboard'),
    },
    {
        path: '/bills',
        name: 'Bills Dashboard',
        component: () => import('@/views/Dashboard'),
    },
    {
        path: '/bills/:bill',
        name: 'Bill',
        meta: {
            layout: 'form',
        },
        component: () => import('@/views/Bill'),
    },
    {
        path: '/airtime-data',
        name: 'Airtime and Data Dashboard',
        component: () => import('@/views/AirtimeData'),
    },
    {
        path: '/transfer/:layout',
        name: 'Funds Transfer Dashboard',
        component: () => import('@/views/FundsTransfer'),
    },
    {
        path: '/paycode',
        name: 'Paycode',
        meta: {
            layout: 'form',
        },
        component: () => import('@/views/Paycode'),
    },
]
